<div class="mt-2">
    <app-basic-card>
        <app-basic-form [form]="form" [keys]="keys"></app-basic-form>

        <h6 class="card-header-label" style="padding-left: 1em;">Lista dei beneficiari</h6>
        <ng-container *ngFor="let beneficiary of currentBeneficiaries">
            <div class="pt-2">
                <app-basic-card>
                    <div class="beneficiary-container align-items-center vertical-align-middle">
                        <div class="d-flex align-items-center vertical-align-middle">
                            <mat-icon class="user-icon" aria-hidden="false" aria-label="user-icon"
                                fontIcon="account_circle">
                            </mat-icon>
                            <ng-container *ngIf="beneficiary.codicebeneficiario !== '6'; else nominativo">
                                {{ evaluateCodiceBeneficiario(beneficiary.codicebeneficiario) }}
                            </ng-container>
                            <ng-template #nominativo>
                                {{ beneficiary.nome || beneficiary.ragioneSociale }} {{ beneficiary.cognome }} {{beneficiary.perc_Beneficio}} %
                            </ng-template>
                        </div>
                        <div class="d-flex align-items-end vertical-align-middle">
                            <mat-icon class="visibility-icon" aria-hidden="false" aria-label="visibility-icon"
                                fontIcon="visibility" [matTooltip]="'Dettaglio'"
                                (click)="openDetail(beneficiary)">
                            </mat-icon>
                            <mat-icon class="remove-icon" aria-hidden="false" aria-label="remove-icon" fontIcon="delete"
                                [matTooltip]="'Rimuovi beneficiario'" (click)="removeBeneficiary(beneficiary)">
                            </mat-icon>
                        </div>
                    </div>
                </app-basic-card>
            </div>
        </ng-container>
        <div class="mt-4 d-flex">
            <button mat-raised-button class="mx-3" color="primary" (click)="openNewBeneficiaryModal()">
                {{ 'aggiungi beneficiario' | uppercase }}
            </button>
        </div>
    </app-basic-card>
</div>